import { isRejectedWithValue, Middleware } from '@reduxjs/toolkit';
import { authSlice } from '@starjack/features/authentication';
import { notify } from '@starjack/features/notifications';

export const authMiddleware: Middleware = (api) => (next) => (action) => {
    if (isRejectedWithValue(action)) {
        // fetchBaseQuery puts the response body under `data`
        const payload = action.payload as
            | { status?: number; data?: { errors?: Array<{ error?: string }> } }
            | undefined;
        if (payload?.status == 401) {
            const error = payload?.data?.errors?.[0];
            if (error?.error === 'token_expired') {
                api.dispatch(
                    authSlice.actions.clearAuthData({
                        userLogout: false,
                    })
                );
            } else {
                notify({
                    type: 'error',
                    message: 'Fehler beim Laden der Daten.',
                    id: 'auth-401',
                });
            }
        }
    }

    // Always forward, otherwise RTK Query never sees the rejection and the request stays pending
    return next(action);
};
